import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOnlineShopActivityList, onlineShopActivityCreate, getOnlineShopAreaList, getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { updateSysDictionaryDetail, findSysDictionaryDetail } from '@/api/sysDictionaryDetail'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import { removeImgUrlSuffix } from '@/utils/stringFun';
import infoList from '@/mixins/infoList';
import UploadImage from '@/components/upload/image';
import Draggable from 'vuedraggable';

var _this;

export default {
  name: 'OnlineShopSettingManage',
  components: {
    UploadImage: UploadImage,
    Draggable: Draggable
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        return formatTimeToStr(time, 'yyyy-MM-dd hh:mm:ss');
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      formData: {
        sellerId: ''
      },
      tabSel: 'home',
      shopConfig: {},
      themeSel: {},
      themeList: [{
        name: 'red',
        color: '#ff0036'
      }, {
        name: 'yellow',
        color: '#f6c133'
      }, {
        name: 'black',
        color: '#333333'
      }, {
        name: 'green',
        color: '#20a53a'
      }, {
        name: 'orange',
        color: '#fe6f04'
      }, {
        name: 'blue',
        color: '#1677ff'
      }, {
        name: 'brown',
        color: '#8B4513'
      }, {
        name: 'purple',
        color: '#623cec'
      }],
      sellerOptions: [],
      jumpTypeOptions: [{
        'name': '无',
        value: 0
      }, {
        'name': '链接',
        value: 1
      }, {
        'name': '本小程序页面',
        value: 2
      }, {
        'name': '三方小程序页面',
        value: 3
      }],
      jumpUrlOptions: [],
      areaOptions: [],
      currentItem: null,
      currentSubItem: null,
      addImgUrl: '',
      menuLocationTypeList: [1, 2, 3, 5, 7],
      dataList: []
    };
  },
  computed: {},
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示都会调用
              console.log('activated');

              _this2.init();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions, configRes, emptyList, res, areaRes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;
                _this3.formData.sellerId = _this3.formData.sellerId ? _this3.formData.sellerId : _this3.sellerOptions[0].sellerId;
                _context3.next = 7;
                return _this3.filterDictItem(2, 'onlineshopConfig');

              case 7:
                configRes = _context3.sent;
                _context3.next = 10;
                return findSysDictionaryDetail({
                  ID: configRes.ID
                });

              case 10:
                configRes = _context3.sent;
                configRes = configRes.data.resysDictionaryDetail;
                _this3.shopConfig = configRes;
                _this3.themeSel = JSON.parse(configRes.label || '{}');
                emptyList = _this3.menuLocationTypeList.map(function (item) {
                  return {
                    'menuLocationType': item,
                    'menuList': []
                  };
                });
                _context3.next = 17;
                return getOnlineShopActivityList({
                  'sellerId': _this3.formData.sellerId,
                  'menuLocationTypeList': _this3.menuLocationTypeList
                });

              case 17:
                res = _context3.sent;
                res.data.menuTypeList = res.data.menuTypeList || [];
                res.data.menuTypeList.forEach(function (item) {
                  item.menuList.forEach(function (subItem) {
                    subItem.checked = false;
                  });
                  emptyList = emptyList.filter(function (item2) {
                    return item2.menuLocationType != item.menuLocationType;
                  });

                  _this3.dataList.push(item);
                });
                _this3.dataList = _this3.dataList.concat(emptyList);

                _this3.onTabSelect(_this3.tabSel);

                if (!(_this3.jumpUrlOptions.length === 0)) {
                  _context3.next = 28;
                  break;
                }

                _this3.jumpUrlOptions = [{
                  'name': '我的优惠券',
                  'path': '/pagesA/bairun-mycoupon/bairun-mycoupon'
                }, {
                  'name': '我的订单',
                  'path': '/pagesA/bairun-myorder/bairun-myorder'
                }];
                _context3.next = 26;
                return getOnlineShopAreaList({
                  'sellerId': _this3.formData.sellerId,
                  'dataType': 1,
                  'page': 1,
                  'pageSize': 99999
                });

              case 26:
                areaRes = _context3.sent;
                areaRes.data.list && areaRes.data.list.forEach(function (item) {
                  var row = {
                    'name': item.showAreaName,
                    'path': '/pagesB/bairun-goods-activity/bairun-goods-activity?showAreaNo=' + item.showAreaNo,
                    'showAreaNo': item.showAreaNo
                  };

                  _this3.jumpUrlOptions.push(row);

                  _this3.areaOptions.push(row);
                });

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onThemeChecked: function onThemeChecked(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.themeSel = item;
                _this4.shopConfig.label = JSON.stringify(item);
                _context4.next = 4;
                return updateSysDictionaryDetail(_this4.shopConfig);

              case 4:
                res = _context4.sent;

                if (res.code == 0) {
                  _this4.$message({
                    type: 'success',
                    message: '主题色设置成功！'
                  });
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onTabSelect: function onTabSelect(name) {
      this.tabSel = name;

      if (name === 'home') {
        this.onItemSelect(1);
        return;
      }

      if (name === 'user') {
        this.onItemSelect(7);
        return;
      }

      this.currentItem = {};
      this.$message({
        type: 'error',
        message: '该页面不可编辑，仅供参考'
      });
      return;
    },
    onItemSelect: function onItemSelect(menuLocationType) {
      var _this5 = this;

      this.dataList.forEach(function (item) {
        if (item.menuLocationType == menuLocationType) {
          _this5.currentItem = item;
        }
      });

      if (this.currentItem && this.currentItem.menuList && this.currentItem.menuList.length) {
        this.onSubItemSelect(this.currentItem.menuList[0]);
      } else {
        this.currentSubItem = null;
      }

      this.addImgUrl = '';
      this.$forceUpdate();
    },
    onSubItemSelect: function onSubItemSelect(subItem) {
      this.currentItem.menuList.forEach(function (item) {
        item.checked = false;
      });
      subItem.checked = true;
      this.currentSubItem = subItem;
      this.$forceUpdate();
    },
    initRowSingle: function initRowSingle(menuLocationType) {
      return {
        'menuName': '',
        'menuLocationType': menuLocationType || '',
        'imgUrl': '',
        'jumpType': 2,
        'menuStatus': 5,
        'startTime': '',
        'endTime': '',
        'showAreaNo': '',
        'appid': '',
        'weight': 0,
        'checked': false
      };
    },
    // 上传成功
    imgUploadSuccess: function imgUploadSuccess(res) {
      var row = this.initRowSingle(this.currentItem.menuLocationType);
      row.imgUrl = res.data.file.url;
      this.currentItem.menuList.push(row);
      this.$forceUpdate();
    },
    // 删除对象
    onDeleteItem: function onDeleteItem(index) {
      this.currentItem.menuList.splice(index, 1);
      this.$forceUpdate();
    },
    // 添加对象
    onAddItem: function onAddItem() {
      var row = this.initRowSingle(this.currentItem.menuLocationType);
      this.currentItem.menuList.push(row);
      this.$forceUpdate();
    },
    // 添加图片链接
    onAddImgUrl: function onAddImgUrl() {
      if (this.addImgUrl.trim() !== '') {
        var row = this.initRowSingle(this.currentItem.menuLocationType);
        row.imgUrl = removeImgUrlSuffix(this.addImgUrl.trim());
        this.currentItem.menuList.push(row);
        this.addImgUrl = '';
        this.$forceUpdate();
      }
    },
    getShowAreaNo: function getShowAreaNo(path) {
      var showAreaNo = '';
      this.areaOptions.forEach(function (item) {
        if (item.path === path) {
          showAreaNo = item.showAreaNo;
        }
      });
      return showAreaNo;
    },
    onSave: function onSave() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var param, maxWeight, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                param = JSON.parse(JSON.stringify(_this6.currentItem));
                param.sellerId = _this6.formData.sellerId;
                maxWeight = param.menuList.length;
                param.menuList.forEach(function (item) {
                  item.startTime = '2023-01-01 00:00:00';
                  item.endTime = '2099-01-01 00:00:00';
                  item.weight = Number((maxWeight * 100).toFixed(0));
                  item.showAreaNo = _this6.getShowAreaNo(item.jumpUrl);
                  maxWeight--;
                });
                _context5.next = 6;
                return onlineShopActivityCreate(param);

              case 6:
                res = _context5.sent;

                if (res.code == 0) {
                  _this6.$message({
                    type: 'success',
                    message: '保存成功！'
                  });
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};